export const getErrorMessage = (
  error: unknown,
  fallback = "Ocurrió un error inesperado.",
): string => {
  if (error && typeof error === "object" && "response" in error) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- preexistente, ver ticket de tipado
    const response = (error as any).response;
    return response?.data?.message ?? response?.data?.error ?? fallback;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
};
